import { useState } from "react";
import axios from "axios";
import { Card, Button } from "../../../components";
import { CHANGE_PASSWORD_URL } from "../../../features/UrlHelper";

/**
 * Zmena hesla prihlaseneho pouzivatela.
 *
 * Spolocna pre `ProfilObsluhy` aj zakaznicky profil
 * -- inak by v projekte boli dva formulare na to iste, ktore by sa
 * postupne rozisli.
 *
 * MINIMALNA DLZKA je 8 znakov -- zhodne s `services/passwords.js` na serveri
 * (`chybaHesla`). Keby tu bolo menej, pouzivatel by dostal az serverovu chybu
 * po odoslani.
 */
const MIN_DLZKA = 8;

function ZmenaHeslaKarta() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordChanging, setPasswordChanging] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handleChangePassword = (e) => {
    e.preventDefault();
    setPasswordError("");
    setPasswordMessage("");

    if (!currentPassword || !newPassword || !confirmPassword) {
      setPasswordError("Všetky polia sú povinné.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setPasswordError("Nové heslá sa nezhodujú.");
      return;
    }
    if (newPassword.length < MIN_DLZKA) {
      setPasswordError(`Nové heslo musí mať aspoň ${MIN_DLZKA} znakov.`);
      return;
    }

    setPasswordChanging(true);
    axios
      .post(CHANGE_PASSWORD_URL, {
        currentPassword,
        newPassword,
        newPasswordConfirm: confirmPassword,
      })
      .then((res) => {
        setPasswordMessage(res.data.message || "Heslo bolo úspešne zmenené.");
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      })
      .catch((err) => {
        setPasswordError(err.response?.data?.message || "Chyba pri zmene hesla.");
      })
      .finally(() => setPasswordChanging(false));
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Zmena hesla</Card.Title>
      </Card.Header>
      <Card.Body>
        <form className="profile__form" onSubmit={handleChangePassword}>
          <div className="profile__form-field">
            <label className="profile__form-label" htmlFor="profil-heslo-aktualne">
              Aktuálne heslo
            </label>
            <input
              id="profil-heslo-aktualne"
              type="password"
              className="profile__form-input"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Zadajte aktuálne heslo"
              autoComplete="current-password"
            />
          </div>
          <div className="profile__form-row">
            <div className="profile__form-field">
              <label className="profile__form-label" htmlFor="profil-heslo-nove">
                Nové heslo
              </label>
              <input
                id="profil-heslo-nove"
                type="password"
                className="profile__form-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder={`Min. ${MIN_DLZKA} znakov`}
                autoComplete="new-password"
              />
            </div>
            <div className="profile__form-field">
              <label className="profile__form-label" htmlFor="profil-heslo-potvrdenie">
                Potvrdenie hesla
              </label>
              <input
                id="profil-heslo-potvrdenie"
                type="password"
                className="profile__form-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Zopakujte nové heslo"
                autoComplete="new-password"
              />
            </div>
          </div>
          {passwordError && <p className="profile__form-error">{passwordError}</p>}
          {passwordMessage && <p className="profile__form-success">{passwordMessage}</p>}
          <div className="profile__form-actions">
            <Button type="submit" variant="primary" disabled={passwordChanging}>
              {passwordChanging ? "Mením heslo..." : "Zmeniť heslo"}
            </Button>
          </div>
        </form>
      </Card.Body>
    </Card>
  );
}

export default ZmenaHeslaKarta;
